import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShoppingCartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shopping_cart"}/>
}
